class globalParam {

    getAppName(){
        return "crypto_tycoon";
    }

    getVersion(){
        return "ver 30";
    }


    getTotalItems(){
        // return 3;
        return 15;
    }
}

const v = new globalParam();
export default v;